import { handleActions } from 'redux-actions';
import { reduxKey } from './constants';
import { ConfigState } from './types';
import { initialize } from './actions';

const actionHandler = handleActions<ConfigState, any>(
  {
    [initialize.toString()]: (state, { payload: { config } }: ReturnType<typeof initialize>) => ({
      ...state,
      ...config,
    }),
  },
  {
    csrfToken: '',
    sharedApiBasePath: '',
  }
);

export default {
  [reduxKey as string]: actionHandler,
};
